import React from 'react';
import { Form, Checkbox, Card } from 'antd';

const Section12Declaration = () => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 12</span>
        <h3>Student Declaration</h3>
        <p className="section-description">
          Please carefully read and accept each declaration statement before final submission.
        </p>
      </div>

      <Card className="declaration-card" bordered={false}>
        <div className="declaration-list">
          <Form.Item
            name="declarationAccurate"
            valuePropName="checked"
            className="declaration-item-row"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Please confirm the accuracy of your information')),
              },
            ]}
          >
            <Checkbox>
              <span>I confirm that the information provided by me is accurate, current, and complete.</span>
            </Checkbox>
          </Form.Item>

          <Form.Item
            name="declarationGenuine"
            valuePropName="checked"
            className="declaration-item-row"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Please confirm authenticity of documents')),
              },
            ]}
          >
            <Checkbox>
              <span>I confirm that the documents uploaded by me are genuine and belong to me.</span>
            </Checkbox>
          </Form.Item>

          <Form.Item
            name="declarationAuthorizeVerification"
            valuePropName="checked"
            className="declaration-item-row"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Please authorize the verification')),
              },
            ]}
          >
            <Checkbox>
              <span>I authorize the Institute to verify the submitted information and documents for academic and administrative purposes.</span>
            </Checkbox>
          </Form.Item>

          <Form.Item
            name="declarationCertNameConfirmed"
            valuePropName="checked"
            className="declaration-item-row"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Please confirm your certificate name declaration')),
              },
            ]}
          >
            <Checkbox>
              <span>I confirm that the name provided for certificate purposes is correct and understands it cannot be altered once printed.</span>
            </Checkbox>
          </Form.Item>

          <Form.Item
            name="declarationDeliveryConfirmed"
            valuePropName="checked"
            className="declaration-item-row"
            rules={[
              {
                validator: (_, value) =>
                  value ? Promise.resolve() : Promise.reject(new Error('Please confirm your delivery details declaration')),
              },
            ]}
            style={{ marginBottom: 0 }}
          >
            <Checkbox>
              <span>I confirm that the certificate delivery information provided by me is correct.</span>
            </Checkbox>
          </Form.Item>
        </div>
      </Card>
    </div>
  );
};

export default Section12Declaration;
